import React, { useEffect, useState } from 'react'
import Button from "@mui/material/Button";
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';

const AssignInterfaceRole = (props) => {
  const { userID } = props;
  const [roleList, setRoleList] = useState([])
  const [users, setUsers] = useState([])
  const [success, setSucces] = useState(false)
  const [roleError, setRoleError] = useState("")
  const [userError, setUserError] = useState("")
  const [assignRole, setAssignRole] = useState({
    role: "",
    user: "",
    referenceNumber: ""
  })

  const handleFormControl = (e) => {
    setRoleError("")
    setUserError("")
    setAssignRole({ ...assignRole, [e.target.name]: e.target.value })
  }
  const onRoleSubmit = (e) => {
    e.preventDefault()

    if (assignRole.role === "" && assignRole.user === "") {
      setRoleError("Required")
      setUserError("Required")
      return 0;
    }
    if (assignRole.role === "" || assignRole.role === "Select Role") {
      setRoleError("Required")
      return 0;
    }
    if (assignRole.user === "" || assignRole.user === "Select User") {
      setUserError("Required")
      return 0;
    }

    let postObject = {
      "role": assignRole.role,
      "referenceNumber": assignRole.referenceNumber,
      "assignedTo": assignRole.user,
      "userId": userID
    }

    Axios({
      method: "PUT",
      url: `${API_URL_UMS}/audit/user-role`,
      data: postObject,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        setSucces(true)
        setTimeout(() => {
          setSucces(false)
        }, 5000)
      })
      .catch((err) => {
      });
  }

  useEffect(() => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      `${API_URL_UMS}audit/role`,
      requestOptions
    )
      .then((response) => {
        setRoleList(response.data)
      })
      .catch((error) => {
      });

    Axios.get(
      `${API_URL_UMS}audit/users`,
      requestOptions
    )
      .then((response) => {
        setUsers(response.data)
      })
      .catch((error) => {
      });
  }, [])

  return (
    <div className='row mt-3'>
      <div className='col-md-6 mx-auto card p-3'>
        <form className='formField'>
          <div className="form-group row">
            <label htmlFor="validationScreen" className="col-sm-4 col-form-label">Role<span className='text-danger'>*</span> :</label>
            <div className="col-sm-6">
              <select onChange={handleFormControl} name="role" class={`form-select ${roleError && "formValidation"}`} aria-label="Default select example">
                <option selected>Select Role</option>
                {roleList && roleList.length > 0 && roleList.map((item) => <option value={item.role}>{item.role}</option>)}
              </select>
              <small id="validationSubScreen" class="form-text text-right text-danger">{roleError}</small>
            </div>

          </div>
          <div className="form-group row">
            <label htmlFor="validationSubScreen" className="col-sm-4 col-form-label">User<span className='text-danger'>*</span> :</label>
            <div className="col-sm-6">
              <select onChange={handleFormControl} name="user" class={`form-select ${userError && "formValidation"}`} aria-label="Default select example">
                <option selected>Select User</option>
                {users && users.length > 0 && users.map((item) => <option value={item.userId}>{item.userId}</option>)}
              </select>
              <small id="validationSubScreen" class="form-text text-right text-danger">{userError}</small>

            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="referenceNumber" className="col-sm-4 col-form-label text-nowrap">Reference Number</label>
            <div className="col-sm-6">
              <input type="text" name="referenceNumber" onChange={handleFormControl} className="form-control" id="referenceNumber" value={assignRole.referenceNumber} />
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-success text-center">
              <span >{success && "Role Assigned"}</span>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <Button
                variant="contained"
                className="btncolor"
                size="small"
                type="submit"
                sx={{ m: 1 }}
                onClick={onRoleSubmit}
              >
                Assign
              </Button>
            </div>
          </div>

        </form>
      </div>
    </div>
  )
}

export default AssignInterfaceRole